
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/react-chat/backend/adapters",
      function () {
        return require("private-next-pages/x/react-chat/backend/adapters.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/react-chat/backend/adapters"])
      });
    }
  